import { DsLink } from '@frontends/ds';
import { DsIcon } from '@frontends/ds-icons';
import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useEntityConfig } from '@/hooks/useEntityConfig';

export function ShareFeedbackLink(): ReactElement | null {
  const { t } = useTranslation();
  const config = useEntityConfig();

  if (!config.VITE_IB_FEEDBACK_EMAIL) {
    return null;
  }

  return (
    <DsLink
      variant="subtle"
      href={`mailto:${config.VITE_IB_FEEDBACK_EMAIL}`}
      className="gap-1.5 whitespace-nowrap text-base font-medium"
    >
      <DsIcon name="mail" size="sm" aria-hidden />
      {t('share_feedback')}
    </DsLink>
  );
}
